<div class="mfa_header">
  <!-- Back Button -->
  @if (shouldShowBackButton()) {
    <button
      cari-interactive-button
      [attr.data-size]="'large'"
      [label]="'ARIA_LABELS.BACK' | translate"
      [attr.title]="'ARIA_LABELS.BACK' | translate"
      (click)="goBack()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="currentColor"
      >
        <path
          d="m313-440 196 196q12 12 11.5 28T508-188q-12 11-28 11.5T452-188L188-452q-6-6-8.5-13t-2.5-15q0-8 2.5-15t8.5-13l264-264q11-11 27.5-11t28.5 11q12 12 12 28.5T508-715L313-520h447q17 0 28.5 11.5T800-480q0 17-11.5 28.5T760-440H313Z"
        />
      </svg>
    </button>
  }

  <h2 class="title">
    {{ titleKey() | translate }}
  </h2>

  <!-- Close Button -->
  @if (currentView() !== MfaViewType.BackupCodes) {
    <button
      cari-interactive-button
      [attr.data-size]="'large'"
      [label]="'ARIA_LABELS.CLOSE' | translate"
      [attr.title]="'ARIA_LABELS.CLOSE' | translate"
      (click)="closeModal(false)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5em"
        height="1.5em"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 13.9L7.09999 18.8C6.91665 18.9834 6.68332 19.075 6.39999 19.075C6.11665 19.075 5.88332 18.9834 5.69999 18.8C5.51665 18.6167 5.42499 18.3834 5.42499 18.1C5.42499 17.8167 5.51665 17.5834 5.69999 17.4L10.6 12.5L5.69999 7.60005C5.51665 7.41672 5.42499 7.18338 5.42499 6.90005C5.42499 6.61672 5.51665 6.38338 5.69999 6.20005C5.88332 6.01672 6.11665 5.92505 6.39999 5.92505C6.68332 5.92505 6.91665 6.01672 7.09999 6.20005L12 11.1L16.9 6.20005C17.0833 6.01672 17.3167 5.92505 17.6 5.92505C17.8833 5.92505 18.1167 6.01672 18.3 6.20005C18.4833 6.38338 18.575 6.61672 18.575 6.90005C18.575 7.18338 18.4833 7.41672 18.3 7.60005L13.4 12.5L18.3 17.4C18.4833 17.5834 18.575 17.8167 18.575 18.1C18.575 18.3834 18.4833 18.6167 18.3 18.8C18.1167 18.9834 17.8833 19.075 17.6 19.075C17.3167 19.075 17.0833 18.9834 16.9 18.8L12 13.9Z"
          fill="currentColor"
        />
      </svg>
    </button>
  }
</div>

<!-- TOTP MFA Turn On -->
@if (currentView() === MfaViewType.Totp) {
  <div class="mfa_content">
    <app-two-step-verification
      (backupCodes)="handleBackupCodesResult($event)"
    />
  </div>
}

<!-- MFA Backup Codes Modal -->
@if (currentView() === MfaViewType.BackupCodes) {
  <div>
    <app-backup-mfa-codes-modal [backupCodes]="backupCodes" />
  </div>
}
